export const Header = ({
    attributes,
    searchTerm,
    setSearchTerm,
    activeCategory,
    setActiveCategory,

}) => {

    const { faqOptions = {}, faqHeader = {}, faqData } = attributes;
    const { displayHeader, displaySearchBar, displayCategory, displayHeadingTitle, displayHeadingDescription } = faqOptions;

    const unique = [...new Set(faqData.map(f => f.categories))];
    const categories = ["all", ...unique]

    return (
        <>
            {
                displayHeader === true && <div className='header-Container'>
                    {
                        displayHeadingTitle && <h1 className='faq-header-title'>{faqHeader?.title}</h1>
                    }

                    {
                        displayHeadingDescription && <p className='faq-header-subtitle'>
                            {faqHeader?.subTitle}
                        </p>
                    }

                    {
                        displaySearchBar === true && <div className="search-container">
                            <div className="search-box">
                                <i className="fa-solid fa-magnifying-glass"></i>
                                <input
                                    type="text" id="searchInput"
                                    placeholder="Search questions..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />

                                {
                                    searchTerm &&
                                    <button
                                        className="clear-search"
                                        onClick={() => setSearchTerm("")}
                                        title="Clear search"
                                    >
                                        X
                                    </button>
                                }

                            </div>
                        </div>
                    }

                    {displayCategory === true && (
                        <div className="category-filter">
                            {categories.map((cat) => (
                                <button
                                    key={cat}
                                    className={`category-btn ${activeCategory === cat ? "active" : ""}`}
                                    onClick={() => setActiveCategory(cat)}
                                >
                                    {cat === "all" ? "All" : cat.charAt(0).toUpperCase() + cat.slice(1)}
                                </button>
                            ))}
                        </div>
                    )}

                </div>
            }
        </>
    )
}